import { Button, FlexBox } from '@fable/components'
import { css, useTheme } from '@fable/theme'
import { ShareObjectType } from '@fable/types'
import { useShareObject } from './useShareObject'

interface Props {
  id: string
  type: ShareObjectType
  name?: String
}

export const SharePageActions = ({ id, type, name }: Props) => {
  const { mediaQueries, colors } = useTheme()
  const { onClickCta } = useShareObject()
  const firstName = name?.split(' ')[0]

  const getPrimaryCTAContent = () => {
    switch (type) {
      case 'list':
        return 'See the full list in the app'
      case 'user-post':
        return 'See the full post in the app'
      case 'editorial-post':
        return 'Read the full post in the app'
      case 'review':
        return 'Read the review on Fable'
      case 'quote':
        return 'Discover the full book on Fable'
    }
  }

  const getDeepLink = () => {
    if (type === 'user-post' || type === 'editorial-post') {
      const deeplink = 'https://universal.fable.co/app/user_posts'
      return `${deeplink}/${id}`
    }

    return ''
  }

  return (
    <FlexBox
      className={css`
        margin-top: 16px;
        ${mediaQueries.mobileL} {
          margin-top: 24px;
        }
      `}
      flexDirection="column"
      gap="8px"
    >
      <Button
        width="100%"
        onClick={() =>
          onClickCta({
            id,
            type,
            cta: 'primary',
            title: "There's more to see in the app",
            description: `Create a free Fable account to see more from ${firstName}!`,
            deepLink: getDeepLink(),
          })
        }
      >
        {getPrimaryCTAContent()}
      </Button>
      {!!name?.length ? (
        <Button
          className={css`
            border-color: ${colors.uiPewterGreyLight};
            ${mediaQueries.mobileL} {
              border-color: ${colors.uiWhite};
            }
          `}
          width="100%"
          onClick={() =>
            onClickCta({
              id,
              type,
              cta: 'secondary',
              title: `To follow ${firstName}, create a free Fable account.`,
            })
          }
          negative
        >
          Follow {firstName} on Fable
        </Button>
      ) : null}
    </FlexBox>
  )
}
